import { useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import React, { ReactElement, ReactNode } from 'react';

type Props = {
  children: ReactElement | ReactNode;
  mapHeight: number;
};

const LegendWrapper: React.FC<Props> = ({ children }) => {
  const theme = useTheme();

  return (
    <motion.div
      style={{
        position: 'absolute',
        right: 0,
        bottom: 0,
        backgroundColor: theme.colors.darkTheme.grey.medium,
        borderRadius: '12px',
        margin: '10px',
        padding: '8px',
        overflowY: 'auto',
        opacity: 0.95,
      }}
    >
      {children}
    </motion.div>
  );
};

export default LegendWrapper;
